import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Vendors } from "./vendors.entity";

@Entity('vendor_address')
export class Address {

    @PrimaryGeneratedColumn("increment",{name:'v_address_id'})
    vAddressId:number;
    @Column("varchar",{
        nullable:true,
        length:50,
        name:"street"
        })
    street:string;
    @Column("varchar",{
        nullable:true,
        length:50,
        name:"apartment"
        })
    apartment:string;
    @Column("varchar",{
        nullable:true,
        length:50,
        name:"city"
        })
    city:string;
    @Column("varchar",{
        nullable:true,
        length:50,
        name:"postal_code"
        })
    postalCode:string;
    
    @Column("varchar",{
        nullable:true,
        length:50,
        name:"gst_number"
        })
      gstNumber:string;

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
        isActive:boolean;
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(()=>Vendors,vendor=>vendor.addressInfo,{nullable:false})
    @JoinColumn({name:'vendor_id'})
    vendorData: Vendors
}